module.exports = __webpack_public_path__ + "media/hero-video-comp.240f904c.mp4";